import React, {useEffect, useRef, useState} from "react";
import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css'
import "./Slider.css"
import {LazyImage} from "..";

function AsyncImg({image}) {
    return(
        <div>
            Image...
        </div>
    )
}


function Slider(props) {


    const swiper = useRef(null)
    const Loop = ()=>{
        setInterval(()=>{
            try{
                swiper.current.slidePrev();
            }catch (e) {
                // console.log(e)
            }
        },8000)
    }




    useEffect(()=>{

        console.log("props ",props.item);

        const GoToSlide = (item) =>{

        }

        if(props.data){
            swiper.current=new Swiper(`.swiper-container-${props.uid}`,{
                loop:true
            })
            try{
                swiper.current.on("click", function(e) {
                    /* do something */
                    // console.log(this.clickedSlide.attributes[1].value);
                    // console.log(props.data[parseInt(this.clickedSlide.attributes[1].value)])
                    let item = props.data[parseInt(this.clickedSlide.attributes[1].value)];
                    props.dispatch(item.link_to,item)
                });
            }catch (e) {
                // console.log(e)
            }

        }
        Loop();
    },[])


    // onClick={() => props.dispatch(item.link_to,item)}
    return(
        <div style={props.item.order!==1?{margin: "32px 16px 0 16px"}:{}}>
            {props.item.title?<div className="section-title"><span>{props.item.title}</span></div>:null}
        <div className="slider_container"
             style={{overflowX:"hidden",backgroundImage: props.item && props.item.background_image? `url(${props.item.background_image})` : ''}}
        >
            {props.data?<div className={`swiper-container-${props.uid} swiper1`}>
                <div className="swiper-wrapper">
                    {props.data.map(item=>{
                        return(
                            <div key={item.uid} className="swiper-slide" >
                                <img alt={"slider"+item.uid}  src={item.image} />
                                {/*<LazyImage type={"slide"} src={item.image}/>*/}
                            </div>
                        )
                    })}
                </div>
            </div>:null}
        </div>
        </div>
    )
}

export {Slider};
